import React from "react";
import styles from "./First.module.css";
import { Link } from "react-router-dom";
import AttorneysPage from "../../Attorney/Attorney";

function First() {
  return (
    <div>
      <div className={styles.background} id="home">
        <h1>Justice. Integrity. Advocacy.</h1>
        <p>Your rights. Our unwavering commitment.</p>
      </div>

      <div style={{ backgroundColor: "#f5f4f0", paddingTop: "50px" }}>
        <AttorneysPage />
      </div>

      <div className={styles.backgroundText}>
        <div className={styles.contentWrapper}>
          <div className={styles.leftSection} style={{ textAlign: "center" }}>
            <h1>WELCOME TO LIBERTY & JUSTICE ADVOCATES</h1>
          </div>

          <div className={styles.rightSection}>
            <p>
              At Liberty & Justice Advocates, we go beyond legal representation —
              we deliver results that shape futures. Our firm is built on a
              foundation of integrity, strategic insight, and relentless
              advocacy, serving individuals, businesses, and institutions who
              demand exceptional outcomes. When the stakes are high, we stand as
              your trusted partner, safeguarding your rights and advancing your
              interests with precision and dedication.
            </p>
            <Link to="/about" className={styles.learnMore}>
              {/* <span>LEARN MORE &gt;</span> */}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default First;
